import { combineReducers } from "redux";
import AuthReducer from "./AuthReducer";
import UserReducer from "./UserReducer";
import CallsReducer from "./CallsReducer";
import CompanyReducer from "./CompanyReducer";
import OperatorsReducer from "./OperatorsReducer";
import AnalyticsReducer from "./AnalyticsReducer";
import FinancialInsightsReducer from "./FinancialInsightsReducer";
import FinancialDetailReducer from "./FinancialDetailReducer";
import AlgoliaReducer from "./AlgoliaReducer";
import ListsReducer from "./ListsReducer";
import DebriefReducer from "./DebriefReducer";

export const authReducer = combineReducers({
  auth: AuthReducer,
});
export const userReducer = combineReducers({
  user: UserReducer,
});
export const callsReducer = combineReducers({
  calls: CallsReducer,
});
export const listsReducer = combineReducers({
  lists: ListsReducer,
});
export const companyReducer = combineReducers({
  company: CompanyReducer,
});
export const operatorsReducer = combineReducers({
  operators: OperatorsReducer,
});
export const analyticsReducer = combineReducers({
  analytics: AnalyticsReducer,
});
export const financialInsightsReducer = combineReducers({
  financial_insights: FinancialInsightsReducer,
});
export const financialDetailReducer = combineReducers({
  financial_detail: FinancialDetailReducer,
});
export const algoliaReducer = combineReducers({
  algolia: AlgoliaReducer,
});
export const debriefReducer = combineReducers({
  debrief: DebriefReducer,
});

export default combineReducers({
  auth: AuthReducer,
  user: UserReducer,
  calls: CallsReducer,
  operators: OperatorsReducer,
  analytics: AnalyticsReducer,
  financial_insights: FinancialInsightsReducer,
  financial_detail: FinancialDetailReducer,
  algolia: algoliaReducer,
});
